import { MiddlewareAction } from "../middleware";

export enum LenderActions {
  REQUEST_GET_LENDER_CONFIG = "REQUEST_GET_LENDER_CONFIG",
}

export function getLenderConfig(lenderId: string): MiddlewareAction {
  return {
    actionName: LenderActions.REQUEST_GET_LENDER_CONFIG,
    type: "GET",
    url: `/v1/lenders/${lenderId}`,
  };
}
